import styled from "styled-components";

// styles
import { convertPxToRem } from "frontend/components/helpers";
import Heading from "core/Heading";

// styled-components
export const CreatorCountryStyled = styled.div`
    margin-left: ${convertPxToRem({ px: 10.5 })};
`;

export const AuthorStyled = styled(Heading)``;

export const ArtistStyled = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: center;

    margin-bottom: ${convertPxToRem({ px: 20 })};
`;
